
import { useState } from "react";

import GoldenEgg from "../image/GoldenEgg.png";
import SaffronFarm from "../image/SaffronVertical.png";
import BlackForest from "../image/BlackForest.png";
import EcoAshram from "../image/EcoAshram.png";


const categories = {
  Agritech: [
    {
      title: "Golden Egg Smart Farm | Punjab",
      image: GoldenEgg,
      desc: "50,000 Birds | 12L Eggs/Month | Rs. 9.48 CR Annual Profit",
    },
    {
      title: "Saffron Vertical Farm | Indoor Facility",
      image: SaffronFarm,
      desc: "100kg Saffron/Year | Zero Soil | AI Monitoring",
    },
    {
      title: "Black Forest Beehives | 53 Acres",
      image: BlackForest,
      desc: "30,000kg/year | Organic Certified Honey | Rs. 3.6 CR Annual Revenue",
    },
  ],

  // Crypto: [
  //   {
  //     title: "Crypto, BTC, Digital Crypto Mining",
  //     image:
  //       "https://images.unsplash.com/photo-1518546305927-5a555bb7020d",
  //     desc: "BTC Development, Blockchain Technologies etc.",
  //   },
  // ],

  Energy: [
    {
      title: "Bio-Energy, Solar, Ethanol, Lithium EVB",
      image:
        "https://images.unsplash.com/photo-1509391366360-2e959784a276",
      desc: "Technologies, AMC, Royalty, Operation & Management",
    },
  ],

  Design: [
    {
      title: "Eco Ashram | Vedic Park",
      image:
        EcoAshram,
      desc: "Spiritual Healing + Ayurvedic Product Development",
    },
    // {
    //   title: "Themed Park, Malls, Commercial Buildings",
    //   image:
    //     "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab",
    //   desc: "Architecture, Interiors, Master Planning",
    // },
    // {
    //   title: "Property Development",
    //   image:
    //     "https://images.unsplash.com/photo-1460317442991-0ec209397118",
    //   desc: "Property Management & Leasing",
    // },
  ],
};

export default function Projects() {
  const [activeTab, setActiveTab] = useState("Agritech");

  return (
    <div className="min-h-screen bg-gray-100">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-slate-900 via-slate-800 to-slate-900 py-24">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <span className="uppercase tracking-[5px] text-green-400 text-sm">
            Our Portfolio
          </span>

          <h1 className="text-6xl font-bold text-white mt-4">
            Projects
          </h1>

          <p className="mt-6 text-lg text-gray-300 max-w-3xl mx-auto">
            Explore innovative projects across Agritech,
            Crypto, Renewable Energy and Sustainable Design.
          </p>
        </div>
      </section>

      {/* Tabs */}
      <div className="max-w-6xl mx-auto px-6 mt-10">
        <div className="grid grid-cols-2 md:grid-cols-3 rounded-2xl overflow-hidden shadow-lg">
          {Object.keys(categories).map((tab) => (
            <button
              key={tab}
              onClick={() => setActiveTab(tab)}
              className={`py-4 font-semibold transition-all duration-300 ${
                activeTab === tab
                  ? "bg-[#34A56F] text-white"
                  : "bg-slate-700 text-white hover:bg-slate-600"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>
      </div>

      {/* Projects */}
      <div className="max-w-7xl mx-auto py-16 px-6">
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {categories[activeTab].map((project, index) => (
            <div
              key={index}
              className="
                bg-white
                rounded-3xl
                overflow-hidden
                shadow-lg
                hover:shadow-2xl
                transition-all
                duration-500
                hover:-translate-y-2
                group
              "
            >
              <div className="overflow-hidden">
                <img
                  src={project.image}
                  alt={project.title}
                  className="
                    h-72
                    w-full
                    object-fit
                    transition-transform
                    duration-700
                    group-hover:scale-110
                  "
                />
              </div>

              <div className="p-6">
                <h3 className="text-2xl font-bold text-green-600 mb-4">
                  {project.title}
                </h3>

                <p className="text-gray-600 leading-7">
                  {project.desc}
                </p>

                <button
                  className="
                    mt-6
                    px-6
                    py-3
                    bg-green-600
                    hover:bg-green-700
                    rounded-xl
                    text-white
                    font-semibold
                    transition
                  "
                >
                  View Project →
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
